import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { Router } from '@angular/router';
import { UserMasterComponent } from '../user-master/user-master.component';
import { PermissionComponent } from '../permission/permission.component';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { UmsService } from '../ums.service';
import { ModalpopService } from '../modalpop.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { HttpErrorResponse } from '@angular/common/http';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { PermissionDialogBoxComponent } from '../permission-dialog-box/permission-dialog-box.component';

@Component({
  selector: 'app-user-dialog-box',
  templateUrl: './user-dialog-box.component.html',
  styleUrls: ['./user-dialog-box.component.scss']
})
export class UserDialogBoxComponent implements OnInit {
  public showPassword: boolean;
  selectedIndex: number = 0;
  disable: Boolean = true;
  userPermission: any;
  userType: any;
  permissionList = [];
  CustomerSettingView = true;
  UserSettingView = true;
  UserPermissionsView = true;
  userForm: FormGroup;
  readonlyUpdate = false;
  tabEnable = true;
  dialogRef: MatDialogRef<any>;
  userData: any;
  submitpayload: any;
  hidePass: boolean;
  updateButton: boolean;
  submitButton: boolean;
  arrayLogin = [];
  UserSearch: FormGroup;
  userId: any;
  utp: any;
  userCreate = true;
  userUpdate = true;
  constructor(
    public umsService: UmsService,
    private modalPopupService: ModalpopService,
    private fb: FormBuilder,
    public router: Router,
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any , private spinner: NgxSpinnerService,) { }
  @ViewChild(UserMasterComponent, { static: false }) private UserMaster: UserMasterComponent;
  @ViewChild(PermissionComponent, { static: false }) private Permissions: PermissionComponent;
  ngOnInit(): void {

    this.userPermission = JSON.parse(sessionStorage.getItem("userPermission"));
    this.utp = sessionStorage.getItem('usertypeee');
    if (this.utp !== 'Super Admin' && this.utp !== 'Admin') {
      // this.isSuperAdmin= false;
      this.userPermission.forEach(element => {
        if (element.PageName == 'User-Permission' && element.PCreate == false) {
          this.userCreate = false;
        }
        if (element.PageName == 'User-Permission' && element.PUpdate == false) {
           this.userUpdate = false;
        }
        // if (element.PageName == 'User-Permission' && element.PDelete == false) {
        //   this.tehasilDelete = false;
        // }
      });
    }
    window.scroll(0,0)
    this.hidePass = true;
    this.tabEnable =true;
    this.updateButton =false;
    this.submitButton = true;
    this.readonlyUpdate = false;
    
    // this.userId=this.data.selected.LoginId;
    this.userForm = this.fb.group({
      LoginFullName:new FormControl('',[Validators.required, Validators.pattern('^[a-zA-Z ]*$')]),
      LoginPass:new FormControl('',[Validators.required]),
      LoginName:new FormControl('',[Validators.required,Validators.pattern('^[a-zA-z0-9 - &\\s]*$')])
    })
    // this.UserSearch = this.fb.group({
    //   SearchString: new FormControl(''), 
    // }); 

    // this.getUserData();  
    if (this.data.key == "Edit") { 
      this.userId=this.data.selected.LoginId;
      this.prepopulateData(this.data.selected);
    } 
    // else if (this.data.key == "Delete") {
    //  this.DeletePrepopulation(this.data.selected);
    // } else {
    //   // alert(this.data.key)  
    // }
  }

  // keypress() {
  //   this.umsService.SearchUser(this.UserSearch.value,this.pageSize,this.currentPage).subscribe(
  //     (res) => {
  //       this.userData = res.data[0];
  //     }, (ERROR: HttpErrorResponse) => {
  //       this.userData = []; 
  //     });
  // }


  onTabChanged(event: MatTabChangeEvent) {
    if (event.tab.textLabel == 'User Master') {
      this.UserMaster.ngOnInit();//Or whatever name the method is called
      this.disable = true;
    }
    else if (event.tab.textLabel == 'Permission') {
      this.Permissions.ngOnInit();//Or whatever name the method is called
    }

  }



  public tabChanged(tabChangeEvent: MatTabChangeEvent): void {

    this.selectedIndex = tabChangeEvent.index;
  }

  public next() {


    this.disable = false;
    this.selectedIndex += 1;
    // this.Permissions.ngOnInit();
  }

  public prev() {
    this.selectedIndex -= 1;
    // this.UserMaster.ngOnInit();
    this.disable = true;
  }

  public enable() {
    this.disable = false;
    // this.Permissions.ngOnInit();
  }


  ngOnChanges(changes: UserDialogBoxComponent) {
  }
  redirect(to): void {
    this.router.navigate([to]);
  }


  submit(){
    if(this.userForm.invalid){
      this.userForm.get('LoginFullName').markAsTouched();
      this.userForm.get('LoginName').markAsTouched();
      this.userForm.get('LoginPass').markAsTouched();
      return;
    }else{
this.saveUser();
    }
  }
  saveUser() {
    this.spinner.show();
    this.submitpayload = this.userForm.value;
    this.umsService.addUserForPermission(this.submitpayload).subscribe(res => {
     let user = sessionStorage.setItem('UserName', 'LoginName');
      this.spinner.hide();
      if (res.status) {
        let data = {}
        data['message'] = res.message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        // this.userForm.reset();
        // this.ngOnInit();
        this.dialogRef.afterClosed().subscribe(result => {
          // this.dialogRef2.close();
          // this.addnewrecord(user);
          });
       
      } else {
        this.spinner.hide();
        let data = {}
        data['message'] = res.message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      let data = {}
      data['message'] = ERROR.error.message
      data['title'] = 'Information'
      data['icon'] = 'fas fa-box-open'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    });
  }

  // getUserData() {
  //   let param = 0;
  //   this.umsService.getUsers(param).subscribe((res) => {
  //     this.userData = res.data[0];
  //   });
  // }




  addnewrecord(e) {
    const dialogRef = this.dialog.open(PermissionDialogBoxComponent, {
      width: '37%',
      data: { selected: e, key : "New"},
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(result => {
      // Handle dialog close actions or data
     // this.getCollegeData();
    });
  }


  prepopulateData(id) {
    this.spinner.show();
    let payload = id.LoginId;
    this.tabEnable = false;
    this.hidePass = false;
    this.updateButton =true; 
    this.submitButton = false;
    this.readonlyUpdate = true;
    this.umsService.getOneUsers(payload).subscribe((res) => {
      if (res.status) {
        let data = res.data[0][0];
      
        // let arr1 = [];
        this.arrayLogin.push(
          this.fb.group({
            LoginAccess: new FormControl(res.data[0][0].LoginAccess),
            LoginId: new FormControl(res.data[0][0].LoginId),
            LoginLevel: new FormControl(res.data[0][0].LoginLevel),
            LoginStatus: new FormControl(res.data[0][0].LoginStatus),
          })
        )
        sessionStorage.setItem('loginId', data.LoginId)
        sessionStorage.setItem('loginName', data.LoginFullName)
        this.spinner.hide();
        this.userForm = this.fb.group({
          LoginFullName: new FormControl(data.LoginFullName,Validators.pattern('^[a-zA-Z ]*$')),
          LoginName: new FormControl(data.LoginName,Validators.pattern('^[a-zA-z0-9 - &\\s]*$')),
          LoginPass:new FormControl(data.LoginPass),
        });

      } else {
        let data = {}
        data['message'] = res.message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-box-open'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);

      }

    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      let data = {}
      data['message'] = ERROR.error.message
      data['title'] = 'Information'
      data['icon'] = 'fas fa-box-open'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    });
  }


  reset(){
this.userForm.reset();
this.ngOnInit();
    // this.tabEnable =true;
  }
  Update(){
    this.spinner.show();
    this.updateButton =true;
    this.submitButton = false;
    this.submitpayload = this.userForm.value;
  let arrayLogin1 = []
  this.arrayLogin.push(
    this.fb.group({
      LoginFullName: new FormControl(this.submitpayload.LoginFullName),
        LoginName: new FormControl(this.submitpayload.LoginName),
    })
  )
  const mergedObject = this.arrayLogin.reduce((result, formGroup) => { 
  const formGroupValue = formGroup.getRawValue(); // Get the raw value of the FormGroup 
  return { ...result, ...formGroupValue }; }, {}); 
  
    this.umsService.updateUserForPermission(mergedObject).subscribe(res => {
      sessionStorage.setItem('UserName', 'LoginName');
      this.spinner.hide();
      if (res.status) {
        let data = {}
        data['message'] = res.message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.userForm.reset();
        this.ngOnInit();
      } else {
        this.spinner.hide();
        let data = {}
        data['message'] = res.message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      let data = {}
      data['message'] = ERROR.error.message
      data['title'] = 'Information'
      data['icon'] = 'fas fa-box-open'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    });
  }
  openPermission(e){
    const dialogRef = this.dialog.open(PermissionDialogBoxComponent, {
      width: '37%',
      data: { selected: e, key : "Edit"},
      disableClose: true 
    });
    dialogRef.afterClosed().subscribe(result => {
      // Handle dialog close actions or data 
       // this.getCollegeData(); 
    });
}
}